import React from 'react';
import RadioUncheckedIcon from '@atlaskit/icon/core/radio-unchecked';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

interface TodoItemProps {
	isChecked: boolean;
	description: string;
}

export const TodoItem = ({ isChecked, description }: TodoItemProps) => {
	const { formatMessage } = useIntl();
	return (
		<Inline space="space.075" alignBlock="start">
			{isChecked ? (
				<StatusSuccessIcon
					label={formatMessage(messages.doneNonFinal)}
					color={token('color.icon.success')}
					spacing="spacious"
				/>
			) : (
				<RadioUncheckedIcon
					label={formatMessage(messages.todoNonFinal)}
					color={token('color.icon.accent.gray')}
					spacing="spacious"
				/>
			)}
			<Box as="span" xcss={descriptionStyles}>
				{description}
			</Box>
		</Inline>
	);
};

const descriptionStyles = xcss({
	font: 'font.body',
	color: 'color.text.subtlest',
	paddingBlock: 'space.025',
});
